package gr.tech.GRAttestation.models.api

import kotlinx.serialization.Serializable

@Serializable
data class PaginatedResult<T>(
    val items: List<T>,
    val totalCount: Int
)
